import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleApiService {
  private http = new HttpClient(this.httpBackend);

  constructor(private httpBackend: HttpBackend) {}

  getAppLocales(): Observable<string[]> {
    return this.http.get<string[]>('/assets/app-locales.json');
  }
}
